import { createUserSettingsOptions } from '@/services/setting/setting.options';
import { createUserQueryOptions } from '@/services/auth/auth.options';
import { createFileRoute, Outlet } from '@tanstack/react-router'
import ReportsBase from '@/pages/reports/ReportsBase.page';
import { createPermissionsQueryOptions } from '@/services/rolesPermissions/rolesPermission.options';
import { z } from 'zod';

type Reports = {
  showRecent?: boolean;
}

export const Route = createFileRoute('/_auth/reports')({
  component: () => <ReportsLayout />,
  validateSearch: (search: Reports) => {
    return z.object({
      showRecent: z.boolean().optional(),
    }).parse(search)
  },
  loader: async ({ context }) => {
    const user = await context?.queryClient?.ensureQueryData(createPermissionsQueryOptions(context?.auth?.checkAuthStatus))
    console.log(user)
    console.log(user?.agentid)
    if (!user?.agentid) return
    await Promise.all([
      context?.queryClient?.ensureQueryData(createUserSettingsOptions(user?.agentid)),
    ])
  },
})

const ReportsLayout = () => {
  return (
    <>
      <ReportsBase />
      <Outlet />
    </>
  )
}
